import { memo } from "react";

const TONE_STYLES = {
  primary: { color: "#6B0F1A", bg: "rgba(107,15,26,0.08)", border: "rgba(107,15,26,0.25)" },
  gold: { color: "#B08D57", bg: "rgba(176, 141, 87,0.14)", border: "rgba(176, 141, 87,0.5)" },
  muted: { color: "#4D3F35", bg: "rgba(26,15,10,0.05)", border: "rgba(26,15,10,0.12)" },
};

function StatChipBase({ icon: Icon, label, value, tone = "muted" }) {
  const styles = TONE_STYLES[tone];
  return (
    <div
      className="inline-flex items-center gap-2.5 px-3 py-2 rounded-sm"
      style={{ backgroundColor: styles.bg, border: `1px solid ${styles.border}` }}
      data-testid={`hero-stat-${label.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <Icon className="w-3.5 h-3.5" strokeWidth={2} style={{ color: styles.color }} />
      <div className="leading-tight">
        <div className="font-mono-tag text-[9px] text-[#78584B]">{label}</div>
        <div className="text-xs font-semibold mt-0.5" style={{ color: styles.color }}>{value}</div>
      </div>
    </div>
  );
}

export const StatChip = memo(StatChipBase);
